import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import App from './App';
import store from './store/reducer';
import '@fontsource-variable/figtree';
import '@fontsource-variable/jetbrains-mono';
import './assets/scss/style.scss';
import config from './config';
import reportWebVitals from './reportWebVitals';
import { PreviousLocationProvider } from './context/PreviousLocationContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider
    store={store}
  >
    <BrowserRouter
      basename={config.basename}
    >
      <PreviousLocationProvider>
        <App />
      </PreviousLocationProvider>
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();
reportWebVitals();